'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _businesses = require('./businesses.html');

var _businesses2 = _interopRequireDefault(_businesses);

var _businesses3 = require('./businesses.controller');

var _businesses4 = _interopRequireDefault(_businesses3);

require('./businesses.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var businessesComponent = {
  restrict: 'E',
  bindings: {},
  template: _businesses2.default,
  controller: _businesses4.default,
  controllerAs: 'vm'
};

exports.default = businessesComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/businesses/businesses.component.js
 **/